import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";

@Injectable()
export class DeparmentService {
    httpOptions = {
        headers: new HttpHeaders({
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Request-Method':'POST,GET,OPTIONS',
            'Access-Control-Request-Headers':'Content-Type, Authorization'
        })
    };
    private dataUser = JSON.parse(localStorage.getItem('USER_CURRENT'));
    private uuid = this.dataUser.uuidCompany;
    private currentUser = this.dataUser.name;
    constructor(
        private http: HttpClient
    ) {}

    createDeparment(data: any): Observable<any> {
        let url = `${environment.api.CatalogsApis}/${this.uuid}/departaments`;
        return this.http.post(url, data, this.httpOptions);
    }
    updateDeparment(data,register): Observable<any> {
        let url = `${environment.api.CatalogsApis}/${this.uuid}/departaments/`;
        return this.http.put(url+register,data);
    }
    deleteDeparment(uuid): Observable<any> {
        let url = `${environment.api.CatalogsApis}/${this.uuid}/departaments/${uuid}?currentUser=${this.currentUser}`;
        return this.http.delete(url);
    }
    getDeparment() {
        let shareGet;
        let url = `${environment.api.CatalogsApis}/${this.uuid}/departaments`;
        shareGet = this.http.get(url);
        return shareGet;
    }
}
